import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { logo } from '@metro-ui/tokens';
import { responsiveProp, responsivePropTypes, } from '../utils/responsiveProp';
var getSize = function (variant) { return logo[variant]; };
export var Logo = styled(function (_a) {
    var variant = _a.variant, size = _a.size, className = _a.className, htmlAttributes = __rest(_a, ["variant", "size", "className"]);
    if (!variant.displayName ||
        !Object.keys(logo).includes(variant.displayName))
        return React.createElement("div", null, "No such logo");
    return React.createElement(variant, __assign(__assign({}, htmlAttributes), { className: className }));
})(function (_a) {
    var variant = _a.variant, size = _a.size;
    var config = getSize(variant.displayName);
    if (!config)
        return undefined;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), responsiveProp(size, undefined, function (val) {
        return val &&
            "\n        width: " + config[val].width + ";\n        height: " + config[val].height + ";\n    ";
    }));
});
Logo.propTypes = {
    variant: PropTypes.func.isRequired,
    size: responsivePropTypes(PropTypes.oneOf(['small', 'medium', 'large']))
        .isRequired,
    className: PropTypes.string,
};
var templateObject_1;
//# sourceMappingURL=Logo.js.map